<!--
 * @Descripttion: 我的审批列表
 * @Author: jschen
 * @Date: 2021-09-05 14:28:12
 * @LastEditors: liaoyijun
 * @LastEditTime: 2022-03-23 15:43:38
-->
<template>
    <div v-show="visible" class="right-box">
        <div class="search-container">
            <div class="search-row">
                <div class="title-item">
                    <span>标题</span>
                    <el-input
                        v-model="searchAppOpt.title"
                        placeholder="标题关键字搜索"
                        prefix-icon="el-icon-search"
                        size="small"
                    >
                    </el-input>
                </div>
                <div class="date-item">
                    <span>接收时间</span>
                    <div class="block">
                        <el-date-picker
                            v-model="searchAppOpt.date"
                            type="daterange"
                            :clearable="false"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            size="small"
                            value-format="yyyy-MM-dd"
                            format="yyyy-MM-dd"
                            @change="datePicker"
                        >
                        </el-date-picker>
                    </div>
                </div>
                <div v-show="tertype === 'PC'" class="creator-item">
                    <el-input
                        v-model="searchAppOpt.creatorName"
                        placeholder="发起人搜索"
                        prefix-icon="el-icon-search"
                        size="small"
                    ></el-input>
                </div>
                <div class="search-btn-group">
                    <el-button type="primary" size="small" @click="search">查询</el-button>
                    <el-button size="small" @click="reset">重置</el-button>
                </div>
            </div>
            <div class="search-row">
                <el-select
                    v-show="currentKey === '-1'"
                    v-model="searchAppOpt.handleType"
                    size="mini"
                    class="select-all"
                    style="width: 100px; margin-right: 20px"
                    @change="selectTask"
                >
                    <el-option v-for="item in taskOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <div v-show="currentKey !== '5'" class="title-item" style="margin-right: 20px">
                    <span>流程单号</span>
                    <el-input
                        v-model="searchAppOpt.flowId"
                        placeholder="流程单号搜索"
                        prefix-icon="el-icon-search"
                        size="small"
                    >
                    </el-input>
                </div>
                <el-button size="small" @click="changeLevel(1)">紧急</el-button>
                <el-button size="small" @click="changeLevel(2)">重要</el-button>
                <el-button size="small" @click="changeLevel(3)">一般</el-button>
                <!-- <el-button size="small" @click="changeLevel()">全部</el-button> -->
            </div>
        </div>
        <div class="sort-box">
            <div class="sort-title">
                <span>{{ title }}列表</span>
            </div>
            <div class="search-right-box">
                <div class="sort-right-box">
                    <!-- <el-button
                        v-show="currentKey === '0' && checkPermission('BKPLSP')"
                        size="mini"
                        class="sActive"
                        @click="batchCheck"
                    >
                        补卡批量审批
                    </el-button> -->
                    <el-button v-show="currentKey === '1'" size="mini" class="sActive" @click="setRead('todoRead')">
                        置为已阅
                    </el-button>
                    <el-button v-show="isWorkTell" size="mini" class="sActive" @click="setRead"> 置为已办 </el-button>
                    <el-button plain size="mini" @click="refresh">刷新</el-button>
                </div>
            </div>
        </div>
        <el-table
            :key="currentKey"
            v-loading="loading"
            :data="appRecords"
            size="mini"
            border
            style="width: 100%"
            class="app-table"
            height="calc(100% - 180px)"
            tooltip-effect="dark"
            @selection-change="handleSelectionChange"
            @row-click="rowAppClick"
        >
            <!-- <el-table-column v-if="['1'].includes(currentKey)" type="selection" width="55" align="center">
            </el-table-column> -->
            <el-table-column v-if="isShowSelection" type="selection" width="55" align="center"> </el-table-column>
            <el-table-column label="序号" width="55" align="center">
                <template slot-scope="scope">{{ scope.$index + 1 }}</template>
            </el-table-column>
            <el-table-column prop="title" label="标题" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span
                        ><span :class="levelStyle(scope.row.alarmLevel)">[{{ levelStatus(scope.row.alarmLevel) }}]</span
                        >{{ scope.row.title }}</span
                    >
                </template>
            </el-table-column>
            <el-table-column
                v-if="['-1'].includes(currentKey)"
                prop="handleType"
                label="类型"
                align="center"
                width="100"
            >
                <template slot-scope="scope">
                    <span>{{ parseTaskType(scope.row.handleType) }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="creatorRealName" label="发起人" align="center" width="100"> </el-table-column>
            <el-table-column v-if="showCreatTime" prop="flowCreateDate" label="创建时间" align="center" width="150">
            </el-table-column>
            <el-table-column
                v-if="showCurrentHandlerPeople"
                prop="currentUsers"
                label="当前处理人"
                align="center"
                width="100"
                :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column prop="createDate" sortable label="接收时间" align="center" width="150">
                <template slot-scope="scope">
                    <!-- <span>{{ scope.row.createDate | dateFilter }}</span> -->
                    <span>{{ scope.row.createDate }}</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="processTime"
                :label="[0, 1].includes(searchAppOpt.handleType) ? '停留时间' : isShowTitle"
                align="center"
                width="150"
                :show-overflow-tooltip="true"
            >
                <template slot-scope="scope">
                    <span class="process-color">{{ formatRelayDate(scope.row) }}</span>
                </template>
            </el-table-column>
            <!-- <el-table-column v-if="showColumns" prop="flowStatus" label="审核状态" align="center" width="115"> -->
            <el-table-column v-if="showProcessType" prop="flowStatus" label="流程状态" align="center" width="88">
            </el-table-column>
            <el-table-column v-if="currentKey !== '5'" prop="collect" label="收藏" align="center" width="70">
                <template slot-scope="scope">
                    <el-tooltip
                        v-if="scope.row.flowFrom !== 'EKP_OA'"
                        class="item"
                        effect="dark"
                        :content="!scope.row.collect ? '收藏' : '从收藏移除'"
                        placement="top-end"
                    >
                        <span
                            :class="{
                                'is-star': !scope.row.collect,
                                'is-active-star': scope.row.collect,
                            }"
                            @click.stop="starCollect(scope.row)"
                        ></span>
                    </el-tooltip>
                    <el-tooltip v-else class="item" effect="dark" content="该类型流程暂不支持收藏" placement="top-end">
                        <span class="is-disable-star" @click.stop="starCollect()"></span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <div slot="append" style="width: 100%; height: 30px"></div>

            <div slot="empty" class="empty">
                <img src="@/assets/pics/no-empty.png" />
                <span>暂无内容</span>
            </div>
        </el-table>
        <div class="pagination-box">
            <el-pagination
                :current-page="searchAppOpt.current"
                :page-sizes="[20, 50]"
                :page-size="searchAppOpt.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="searchAppOpt.total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import { batchRead, handleCollect, queryApproval } from "@/api";
import { APPROVE_KEYS as KEYS, HANDLE_TYPE_KEYS } from "@/config/constants";
import { isMobile, formatProcessTime } from "@/libs/mUtils";
import _ from "lodash";

export default {
    props: {
        currentKey: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "",
        },
        visible: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            tertype: "",
            loading: false,
            appRecords: [],
            multipleSelection: [],
            taskOptions: [
                {
                    value: null,
                    label: "全部",
                },
                {
                    value: 0,
                    label: "待审",
                },
                {
                    value: 1,
                    label: "待阅",
                },
                {
                    value: 2,
                    label: "已审",
                },
                {
                    value: 3,
                    label: "已阅",
                },
            ],
            searchAppOpt: {
                creatorName: "",
                flowId: "",
                title: "",
                alarmLevel: null,
                date: "",
                startDate: "",
                endDate: "",
                taskType: 0,
                handleType: 0,
                handleGroup: "All",
                current: 1,
                size: 20,
                total: 0,
            },
        };
    },
    computed: {
        isShowTitle({ searchAppOpt, currentKey }) {
            // "已审" "已阅"
            if (["2", "3"].includes(currentKey)) {
                return "处理用时";
            }
            // 工作沟通已审
            if (searchAppOpt.taskType === 1 && searchAppOpt.handleType === 2) {
                return "处理用时";
            }
            return "流程处理用时";
        },
        isShowSelection({ currentKey, searchAppOpt }) {
            // 全部 待审 "已审" "已阅" 收藏流程 不显示复选框
            if (["-1", "0", "2", "3", "9"].includes(currentKey)) {
                return false;
            }
            // 工作沟通已审 不显示复选框
            if (searchAppOpt.taskType === 1 && searchAppOpt.handleType === 2) {
                return false;
            }
            return true;
        },
        showCreatTime({ currentKey }) {
            // 显示创建时间 待审 已审
            return ["0", "2"].includes(currentKey);
        },
        showProcessType({ currentKey }) {
            // 显示流程状态 全部 已审 收藏 显示
            if (["-1", "2", "9"].includes(currentKey)) {
                return true;
            }
            return false;
        },
        showCurrentHandlerPeople({ currentKey }) {
            // 显示当前处理人 待审 已审
            if (["0", "2"].includes(currentKey)) {
                return true;
            }
            return false;
        },
        levelStatus() {
            return function(status) {
                let level = parseInt(status);
                let levelName = "一般";
                switch (level) {
                    case 1:
                        levelName = "紧急";
                        break;
                    case 2:
                        levelName = "重要";
                        break;
                    default:
                        levelName = "一般";
                        break;
                }
                return levelName;
            };
        },
        levelStyle() {
            return function(level) {
                return `level${level}`;
            };
        },
        parseTaskType() {
            return function(type) {
                return HANDLE_TYPE_KEYS.get(type);
            };
        },
        isWorkTell() {
            return this.searchAppOpt.taskType === 1 && this.searchAppOpt.handleType === 0;
        },
    },
    // watch: {
    //     currentKey(val) {
    //         this.dynamicSetRead(val);
    //     },
    // },
    mounted() {
        this.computeAutoPad();
    },
    methods: {
        search() {
            this.searchAppOpt.current = 1;
            this.loadData();
        },
        loadData() {
            if (this.currentKey === KEYS.ALL) {
                this.searchAppOpt = {
                    ...this.searchAppOpt,
                    taskType: null,
                    handleType: null,
                    handleGroup: "All",
                    isCollect: null,
                };
            }

            if (this.currentKey === KEYS.COLLECT_PROCESS) {
                this.searchAppOpt = {
                    ...this.searchAppOpt,
                    taskType: null,
                    handleType: null,
                    handleGroup: "ALL",
                    isCollect: true,
                };
            }

            this.queryAppList();
        },

        dynamicSetRead(val) {
            this.$nextTick(() => {
                const $th = document.querySelector(".app-table thead th:first-child");
                const $tds = document.querySelectorAll(".app-table tbody td:first-child");
                const showStatus = val === KEYS.TODO_READ ? "" : "none";
                $th.style.display = showStatus;
                $tds.forEach(($td) => {
                    $td.style.display = showStatus;
                });
            });
        },

        fitPadTitle(title) {
            if (this.tertype === "ipad") {
                if (title.length > 22) {
                    return title.slice(0, 22) + "...";
                }
                return title;
            }
            return title;
        },
        changeSearchOps(item) {
            this.searchAppOpt = {
                ...this.searchAppOpt,
                ...item,
            };
        },
        computeAutoPad() {
            this.tertype = document.body.clientWidth > 1220 ? "PC" : "ipad";
        },
        selectTask() {
            this.queryAppList();
        },
        starCollect(row) {
            if (!row) {
                return;
            }
            const { id, collect } = row;
            this.handleCollect({
                id,
                isCollect: !collect,
            });
        },
        // 查询审批列表
        async queryAppList(callback) {
            this.loading = true;
            try {
                const { body, code, message } = await queryApproval({
                    ..._.omit(this.searchAppOpt, ["date", "total"]),
                });
                if (code === "0000") {
                    const { current, records, total } = body;
                    this.appRecords = records;
                    this.searchAppOpt.total = total;
                    this.searchAppOpt.current = current;
                    callback && callback();
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                console.error(err);
            }
            this.loading = false;
        },
        // 查询收藏列表
        async handleCollect(params) {
            this.loading = true;
            try {
                const { code, message } = await handleCollect({
                    ...params,
                });
                if (code === "0000") {
                    const message = params.isCollect ? "已添加至收藏" : "已取消收藏";
                    this.$message[params.isCollect ? "success" : "warning"](message);
                    this.loadData();
                    this.$emit("reload");
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                console.error(err);
            }
            this.loading = false;
        },
        batchCheck() {
            this.$emit("check");
        },
        formatRelayDate(date) {
            const { createDate, finishTime = "" } = date;
            // if (this.searchAppOpt.taskType === 1) {
            //     return formatProcessTime(createDate, "耗时", finishTime);
            // } else {
            //     if ([0, 1].includes(this.searchAppOpt.handleType)) {
            //         return formatProcessTime(createDate);
            //     } else {
            //         return formatProcessTime(createDate, "耗时", finishTime);
            //     }
            // }
            // 根据状态判断是已等待/耗时
            if (date.handleType === "待办" || date.handleType === "待阅") {
                return formatProcessTime(createDate);
            }
            if (date.handleType === "已办" || date.handleType === "已阅") {
                if (date.handleType === "已办" && formatProcessTime(createDate, "耗时", finishTime) === "耗时0秒") {
                    return "耗时5秒";
                }
                return formatProcessTime(createDate, "耗时", finishTime);
            }
            if ([0, 1].includes(this.searchAppOpt.handleType)) {
                return formatProcessTime(createDate);
            } else {
                if (this.title === "已审" && formatProcessTime(createDate, "耗时", finishTime) === "耗时0秒") {
                    return "耗时5秒";
                }
                return formatProcessTime(createDate, "耗时", finishTime);
            }
        },
        // 置为已读
        async setRead(type) {
            if (this.multipleSelection.length === 0) {
                this.$message.error("请先选择列表项！");
                return;
            }
            if (this.multipleSelection.length > 20) {
                this.$message.error("待阅数据最多只能选择20条！");
                return;
            }
            this.loading = true;
            try {
                const ids = this.multipleSelection.map((item) => item.id);
                const { code, message } = await batchRead({
                    ids,
                });
                if (code === "0000") {
                    this.appRecords = _.cloneDeep(this.appRecords).filter((item) => !ids.includes(item.id));
                    this.searchAppOpt.total = parseInt(this.searchAppOpt.total - ids.length);
                    const $el =
                        type === "todoRead"
                            ? `${this.searchAppOpt.handleType}-${this.searchAppOpt.handleGroup}`
                            : "5-0-ALL";
                    // this.queryAppList(() => {
                    this.$emit("queryCount", $el, ids.length, type);
                    // });
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                console.error(err);
            }
            this.loading = false;
        },
        // 刷新
        refresh() {
            this.reset();
        },
        clearKw() {
            this.searchAppOpt = {
                creatorName: "",
                title: "",
                flowId: "",
                alarmLevel: null,
                date: "",
                startDate: "",
                endDate: "",
                current: 1,
                size: 20,
                total: 0,
            };
        },
        reset() {
            const { taskType, handleGroup, handleType } = _.cloneDeep(this.searchAppOpt);
            this.searchAppOpt = {
                creatorName: "",
                title: "",
                flowId: "",
                alarmLevel: null,
                date: "",
                startDate: "",
                endDate: "",
                taskType,
                handleType,
                handleGroup,
                current: 1,
                size: 20,
                total: 0,
            };
            this.loadData();
            this.$emit("reload");
        },
        changeLevel(level) {
            this.searchAppOpt.current = 1;
            this.searchAppOpt.alarmLevel = level;
            this.loadData();
        },
        datePicker(dateArr) {
            const [startDate, endDate] = dateArr;
            this.searchAppOpt.startDate = startDate ? `${startDate} 00:00:00` : "";
            this.searchAppOpt.endDate = endDate ? `${endDate} 23:59:59` : "";
        },
        rowAppClick({ mobileLink, link }) {
            if (isMobile()) {
                window.open(mobileLink);
                return;
            }
            window.open(link);
        },
        // 复选框
        handleSelectionChange(val) {
            // 0-待审；1-待阅
            if ([KEYS.TODO_READ, KEYS.WORK_COMMUNICATE].includes(this.currentKey)) {
                this.multipleSelection = val;
            }
        },
        handleSizeChange(val) {
            this.searchAppOpt.current = 1;
            this.searchAppOpt.size = val;
            this.loadData();
        },
        handleCurrentChange(val) {
            this.searchAppOpt.current = val;
            this.loadData();
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../style.scss";
</style>
